module.exports = __webpack_public_path__ + "assets/b742878791ba0b06161beb2361ba7518.svg";